export const works=[
    {
        Title:"Wetland Digitalization Tool|Geospatial planning and documentation|5 min read",
        Hashtag:"#UserFreedom  #Constrains  #UAT  #GIS",
        Summary:
        [
            {
                line1:"Co-developed a USDA <b>Design System</b>",
                line2:"> Adopted by Multiple Branches",
            },
            {
                line1:"Restructured GIS <b>Layers & Data</b>",
                line2:"> -40% Supporting Tickets",
            },
            {
                line1:"Built <b>Self-guided UI</b>",
                line2:"> +35% Faster Completion",
            }
        ],
        Assets:"wdt",
        ContextItems:
        [
            {
                steps:
                [ 
                    {
                        step_text:"Problem statement",
                        step_link:"problem_statement"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Discovery Research",
                        step_link:"research"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Design Challenges",
                        step_link:"challenges"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Enhancements",
                        step_link:"enhancements"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Validation",
                        step_link:"validation"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impacts",
                        step_link:"impact"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"conclusion"
                    }
                ]
            }
        ]
    },
    {
        Title:"Field Office Technical Guide|AI-powered Information Repository|6 min read",
        Hashtag:"#Research  #UsabilityTest  #Section508",
        Summary:
        [
            {
                line1:"Led <b>Mobile-first Redesign</b>",
                line2:"> +37% Mobile Usage",
            },
            {
                line1:"Spearheaded <b>Smarter Search</b>",
                line2:"> -33% Search Bounce",
            },
            {
                line1:"Introduced <b>RAG AI Assistants</b>",
                line2:"> +300% Information Findability",
            }
        ],
        Assets:"fotg",
        ContextItems:
        [
            {
                steps:
                [
                    {
                        step_text:"Problem statement",
                        step_link:"problem_statement"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Discovery research",
                        step_link:"discovery_research"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Change of Direction",
                        step_link:"change"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Usability Test",
                        step_link:"test"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Mobile-First UI",
                        step_link:"mobile"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"AI Widgets",
                        step_link:"ai"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impact",
                        step_link:"impact"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"conclusion"
                    }
                ]
            }
        ]
    },
    {
        Title:"Small Business Development Center|Public Service Platform|5 min read",
        Hashtag:"#NavigationTest   #VisualHierarchy  #WCAG",
        Summary:
        [
            {
                line1:"Drove <b>Responsive Redesign</b>",
                line2:"> +50% Mobile Traffic",
            },
            {
                line1:"Reorganized <b>Information Architecture</b>",
                line2:"> +62% Session Depth",
            },
            {
                line1:"Optimized <b>Booking Flow</b>",
                line2:"> +29% Appointment Booking",
            }
        ],
        Assets:"sbdc",
        ContextItems:
        [
            {
                steps:
                [
                    {
                        step_text:"Context",
                        step_link:"context"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Research",
                        step_link:"research"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Strategy",
                        step_link:"strategy"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Enhancements",
                        step_link:"enhancements"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impacts",
                        step_link:"impacts"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"conclusion"
                    }
                ]
            }
        ]
    },
    {
        Title:"Conservation Practice Document Document Management System|Document Management System|3 min read",
        Hashtag:"#StakeholderCollaboration #ContextualDesign",
        Summary:
        [
            {
                line1:"Introduced <b>Contextual Functions</b>",
                line2:"> +200% New User Task Success",
            },
            {
                line1:"<b>Consolidated Roles</b> and <b>Simplified Flows</b>",
                line2:"> +47% Faster Approval Cycles",
            },
            {
                line1:"Leveraged <b>SharePoint Integration</b>",
                line2:"> +30% Faster Editing",
            }
        ],
        Assets:"cpd_dms",
        ContextItems:
        [
            {
                steps:
                [
                    {
                        step_text:"Research",
                        step_link:"research"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"User flows",
                        step_link:"user_flows"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Prototype",
                        step_link:"prototype"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impacts",
                        step_link:"impact"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"takeaways"
                    }
                ]
            }
        ]
    },
    {
        Title:"WT System|Contract Management System|6 min read",
        Hashtag:"#Research #Inclusive #Iteration",
        Summary:
        [
            {
                line1:"Redesigned <b>Responsive Web-app</b>",
                line2:"> -59% Printing Counts",
            },
            {
                line1:"Implemented <b>Error Prevention & Recovery</b>",
                line2:"> -35% Supporting Tickets",
            },
            {
                line1:"Enhanced <b>System Visibility</b>",
                line2:"> -67% Reporting Prep time",
            }
        ],
        Assets:"wt",
        ContextItems:
        [
            {
                steps:
                [
                    {
                        step_text:"Context",
                        step_link:"context"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Usability study",
                        step_link:"usability_study"
                    },
                    {
                        step_text:"Heuristic evaluation",
                        step_link:"heuristic_evaluation"
                    },
                    {
                        step_text:"Interviews",
                        step_link:"interviews"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Personas",
                        step_link:"personas"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Pain points",
                        step_link:"pain_points"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Solution 1",
                        step_link:"solution_1"
                    },
                    {
                        step_text:"Solution 2",
                        step_link:"solution_2"
                    },
                    {
                        step_text:"Solution 3",
                        step_link:"solution_3"
                    },
                    {
                        step_text:"Improvements",
                        step_link:"improvements"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Iteration",
                        step_link:"iteration"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impact",
                        step_link:"impact"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"conclusion"
                    }
                ]
            }
        ]
    },
    {
        Title:"Sipps|Mobile Order Applications|7 min read",
        Assets:"sipps",
        Hashtag:"#MobileApp #StartUp",
        Summary:
        [
            {
                line1:"Delivered <b>Full-stack Ordering Solution</b>",
                line2:"> Secured $800k Fund",
            },
            {
                line1:"Designed <b>Native Mobile App</b> for Consumer",
                line2:"> 3500+ Orders, 5.0 Ratings",
            },
            {
                line1:"Launched <b>Merchant App</b> & Label Printer",
                line2:"> Hassle-free Operations",
            }
        ],
        ContextItems:
        [
            {
                steps:
                [
                    {
                        step_text:"Context",
                        step_link:"context"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Consumer app",
                        step_link:"consumer_app"
                    },
                    {
                        step_text:"Research",
                        step_link:"web_research"
                    },
                    {
                        step_text:"Personas",
                        step_link:"personas"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Define",
                        step_link:"define"
                    },
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Ideation",
                        step_link:"ideation"
                    },
                    {
                        step_text:"Competitive audit",
                        step_link:"competitive_audit"
                    },
                    {
                        step_text:"Merchant app",
                        step_link:"merchant_app"
                    },
                    {
                        step_text:"User flow & IA",
                        step_link:"user_flow"
                    },
                    {
                        step_text:"Wireframes",
                        step_link:"wireframes"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Prototype",
                        step_link:"prototype"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Iterations",
                        step_link:"iterations"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Impact",
                        step_link:"impact"
                    }
                ]
            },
            {
                steps:
                [
                    {
                        step_text:"Takeaways",
                        step_link:"conclusion"
                    }
                ]
            }
        ]
    },
]